
(() => {
  if (window.ZentoTitleSearchLoaded) return;
  window.ZentoTitleSearchLoaded = true;

  const cache = new Map();

  const ignoredWords = new Set([
    "sofa", "sofá",
    "sillon", "sillón",
    "silla", "sillas",
    "mesa", "mesas",
    "mueble", "muebles",
    "comedor",
    "recamara", "recámara",
    "dormitorio",
    "cama", "camas",
    "escritorio",
    "librero", "libreros",
    "banco", "bancos",
    "de", "la", "el", "los", "las",
    "para", "con", "y", "title"
  ]);

  const normalize = (value) =>
    value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  function getSearchKeyword(query) {
    const words = normalize(query)
      .replace(/[:"']/g, "")
      .split(/\s+/)
      .filter(Boolean);

    const relevantWords = words.filter(
      (word) => !ignoredWords.has(word) && word.length > 1
    );

    // El último término relevante suele ser el nombre del modelo.
    return relevantWords.at(-1) || words.at(-1) || "";
  }

  function getSearchUrl(keyword, page = 1) {
    const url = new URL(
      `${window.Shopify.routes.root}search`,
      window.location.origin
    );

    url.searchParams.set("q", `title:${keyword}`);
    url.searchParams.set("type", "product");
    url.searchParams.set("section_id", "search-title-results");
    url.searchParams.set("page", page);

    return url.toString();
  }

  async function fetchTitleResults(query, page = 1) {
    const keyword = getSearchKeyword(query);

    if (!keyword || keyword.length < 2) return null;

    const cacheKey = `${keyword}:${page}`;

    if (cache.has(cacheKey)) {
      return cache.get(cacheKey).cloneNode(true);
    }

    const response = await fetch(getSearchUrl(keyword, page));

    if (!response.ok) {
      throw new Error("No se pudieron consultar las coincidencias por título.");
    }

    const html = await response.text();
    const documentHTML = new DOMParser().parseFromString(html, "text/html");
    const results = documentHTML.querySelector("[data-title-search-results]");

    if (!results || !results.querySelector(".product-card")) {
      return null;
    }

    cache.set(cacheKey, results.cloneNode(true));

    return results;
  }

  function getProductHandles(container) {
    return new Set(
      [...container.querySelectorAll(".product-card[data-product]")]
        .map((card) => card.dataset.product)
        .filter(Boolean)
    );
  }

  function removeDuplicateProducts(container, handles) {
    container
      .querySelectorAll(".product-card[data-product]")
      .forEach((card) => {
        if (!handles.has(card.dataset.product)) return;

        const item = card.closest("li");

        if (item) {
          item.remove();
        } else {
          card.remove();
        }
      });
  }

  function insertTitleResults(target, titleResults, relatedContainer) {
    if (!target || !titleResults) return;

    target
      .querySelector("[data-zento-title-results]")
      ?.remove();

    titleResults.dataset.zentoTitleResults = "true";

    const handles = getProductHandles(titleResults);

    if (relatedContainer) {
      removeDuplicateProducts(relatedContainer, handles);
    }

    target.insertBefore(titleResults, target.firstChild);
  }

  async function enhancePredictiveSearch(instance) {
    const query = instance.getQuery();

    if (!query || query.length < 2) return;

    try {
      const titleResults = await fetchTitleResults(query);

      // Evita mostrar resultados de una búsqueda anterior.
      if (instance.getQuery() !== query || !titleResults) return;

      insertTitleResults(
        instance.predictiveSearchResults,
        titleResults,
        instance.predictiveSearchResults
      );
    } catch (error) {
      console.warn("[Zento Search]", error);
    }
  }

  function initializePredictiveSearch() {
    const PredictiveSearch = customElements.get("predictive-search");

    if (!PredictiveSearch) return;

    const prototype = PredictiveSearch.prototype;

    if (prototype.zentoTitleSearchInitialized) return;

    prototype.zentoTitleSearchInitialized = true;

    const originalRenderSearchResults = prototype.renderSearchResults;

    prototype.renderSearchResults = function (resultsMarkup) {
      originalRenderSearchResults.call(this, resultsMarkup);

      enhancePredictiveSearch(this);
    };
  }

  async function enhanceMainSearch() {
    const searchPage = document.querySelector(".template-search");

    if (!searchPage) return;

    const input = searchPage.querySelector("#Search-In-Template");
    const productGrid = searchPage.querySelector("#product-grid");

    if (!input || !productGrid || !input.value.trim()) return;

    const query = input.value.trim();

    const page = Number(
      new URLSearchParams(window.location.search).get("page") || 1
    );

    try {
      const titleResults = await fetchTitleResults(query, page);

      if (!titleResults) return;

      const relatedBlock = productGrid.querySelector(
        ".search-results__block"
      );

      insertTitleResults(
        productGrid,
        titleResults,
        relatedBlock || productGrid
      );

      if (relatedBlock) {
        const remainingProducts = relatedBlock.querySelectorAll(
          ".product-card[data-product]"
        );

        if (remainingProducts.length) {
          const heading = relatedBlock.querySelector(
            ".search-results__title"
          );

          if (heading) {
            heading.textContent = "Productos relacionados";
          }
        } else {
          relatedBlock.remove();
        }
      }
    } catch (error) {
      console.warn("[Zento Search]", error);
    }
  }

  customElements.whenDefined("predictive-search").then(() => {
    initializePredictiveSearch();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceMainSearch);
  } else {
    enhanceMainSearch();
  }
})();
